'use strict';

import { CLOSED, MAXIMIZED, MINIMIZED, RESTORED } from '@/constants/windowConstants';

export default class EcsInteractionWindow {
  constructor(interactionId, currentState = RESTORED, previousState = null) {
    if (!interactionId) {
      return;
    }

    this.interactionId = interactionId;
    this.state = {
      current: currentState,
      previous: previousState
    };
  }

  set currentState(state) {
    if (!state || this.state.current === state) {
      return;
    }

    this.state.previous = this.state.current;
    this.state.current = state;
  }

  get currentState() {
    return this.state.current;
  }

  get previousState() {
    return this.state.previous;
  }

  get isClosed() {
    return this.state.current === CLOSED;
  }

  get isMaximized() {
    return this.state.current === MAXIMIZED;
  }

  get isMinimized() {
    return this.state.current === MINIMIZED;
  }

  get isRestored() {
    return this.state.current === RESTORED;
  }
}
